import swal from 'sweetalert'

const NET_DONE = 0;
const NET_WAIT = 1;


class NetworkService
{
    constructor(app)
    {
        this.app = app;
        this.token = null;
    }

    upload()
    {
        this.app.load_results = true;
        let formData = new FormData();
        let up = this.app.fileUp;
        formData.append("up", up);
        let down = this.app.fileDown;
        formData.append("down", down);
        if (this.app.fileAll !== null)
        {
            formData.append('bg', this.app.fileAll);
        }
        formData.append("param", JSON.stringify(this.app.params));
        return fetch("/api/featgo-service/upload_v2" , {
            method: 'POST',
            headers: {
                "Access-Control-Allow-Origin": "https://webfsgor.sysbio.cytogen.ru/"
            },
            timeout: 0,
            body: formData
        }).then(res => {
            if (res.ok)
            {
                return res.text();
            }
            else {
                return res.text().then(b =>
                {
                    return Promise.reject(b)
                })
            }
        }).then(t =>
        {
            this.token = t;
            localStorage["token"] = t;
            console.log(t);
            return Promise.resolve();
        }).catch(err => {
            swal("Oops!", "Something wrong: " + err, "error");
            this.token = null;
            localStorage.removeItem("token");
            this.app.load_results = false;
        });
    }

    get()
    {
        // let formData = new FormData();
        // formData.append('id', this.token);
        // let url = new URL('/api/featgo-service/get', 'http://localhost:3000/');
        // let params = {id: this.token};
        // Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        // console.log(url);
        return fetch( "/api/featgo-service/get?id=" + this.token , {
                method: 'GET',
                headers: {
                    "Access-Control-Allow-Origin": "https://webfsgor.sysbio.cytogen.ru/"
                },
                timeout: 0,
            }).then(res => {
                if (res.ok) {
                    return res.json();
                }
                else
                {
                    return res.text().then(b => {
                        return Promise.reject(new Error(b))
                    })
                }
            }).then(arg => {
                if (arg.done && !arg.exception) {
                    console.log(arg.result);
                    this.app.svg_file = arg.result["svgResults"];
                    this.app.legend_file = arg.result["svgLegends"];
                    this.app.graph_file = [arg.result["graphResultHtml"], arg.result['graphDownResultHtml']];
                    this.app.tableUp = arg.result["jsonUp"];
                    this.app.tableDown = arg.result["jsonDown"];
                    this.app.tables = [null, null];
                    for (let i in [0, 1])
                    {
                        this.app.tableUp[i] = JSON.parse(this.app.tableUp[i]);
                        this.app.tableDown[i] = JSON.parse(this.app.tableDown[i]);
                    }
                    this.app.tables = [this.app.tableUp, this.app.tableDown];
                    this.app.have_result = true;
                    this.app.load_results = false;
                    localStorage.removeItem("token");
                    return Promise.resolve();
                }
                if (arg.done && arg.exception )
                {
                    return Promise.reject(new Error(arg.result.message))
                }
            }).catch(err => {
               swal("Oops!", "Something wrong: " + err, "error");
               console.log('Request error: ', err);
                this.app.load_results = false;
                this.token = null;
                localStorage.removeItem("token");
                return Promise.reject();
            });
    }

    cancel()
    {

    }
}

export default NetworkService;



// WEBPACK FOOTER //
// ./src/components/NetworkService.js